import { useContext } from 'react';

import MeetRoomContext from './MeetRoomContext';

const useRoomContext = () => {
  const context = useContext(MeetRoomContext);
  if (!context) {
    throw new Error('useRoomContext must be a child of MainProvider');
  }
  return { ...useContext(MeetRoomContext) };
};
export default useRoomContext;
